export enum SweepType {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}
